import { render, staticRenderFns } from "./TagAutoCompleteInput.vue?vue&type=template&id=2bf670d6"
import script from "./TagAutoCompleteInput.vue?vue&type=script&lang=js"
export * from "./TagAutoCompleteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports